export { default as GTM } from './GTM/gtm';
export { default as Money } from './Money/Money';
export { default as downloadFile } from './DownloadFile/DownloadFile';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const objectToFormData = (obj: Record<string, any>, rootName?: string, ignoreList?: string[]): FormData => {
  const formData = new FormData();

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  function appendFormData(data: any, root: string) {
    if (!ignore(root)) {
      root = root || '';
      if (data instanceof File) {
        formData.append(root, data);
      } else if (Array.isArray(data)) {
        for (let i = 0; i < data.length; i++) {
          appendFormData(data[i], root + '[' + i + ']');
        }
      } else if (typeof data === 'object' && data) {
        for (const key in data) {
          if (data.hasOwnProperty(key)) {
            if (root === '') {
              appendFormData(data[key], key);
            } else {
              appendFormData(data[key], root + '[' + key + ']');
            }
          }
        }
      } else {
        if (data !== null && typeof data !== 'undefined') {
          formData.append(root, data);
        }
      }
    }
  }

  function ignore(root: string) {
    return Array.isArray(ignoreList) && ignoreList.some((x) => x === root);
  }

  appendFormData(obj, rootName ?? '');

  return formData;
};

export const isPaymentError = (e: unknown): boolean => {
  return typeof e === 'object' && e !== null && 'status' in e && (e as { status: unknown }).status === 402;
};
